import axios from 'axios';

export default {
  fetchTomList({
    commit,
  }, paginationParams) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get('/tom', {
      params: paginationParams,
    })
      .then((toms) => {
        commit('setData', toms);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  downloadReport(_, id) {
    console.log(`params: ${id}`);

    return axios.get(`/tom/report/${id}`, {
      responseType: 'blob',
      timeout: 30000,
    });
  },
};
